import React, { useState } from 'react';
import Sidebar from './Sidebar';
import TopNav from './TopNavBar';
import MainContent from './MainContent';
import { signOut } from 'aws-amplify/auth';
import { logoutSuccess } from '@store/reducers/auth/loginSlice';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '@store/hooks';
import { LOGIN_PATH } from '@constants/routes';
import ModalPopUp from '@components/ModalPopUpComponent';
import { logout } from '@store/reducers/auth/authReducer';
import { getDataUsingUserId, updateUser } from '@utils/sharedUtils';
import { useAppSelector } from '@store/hooks';
import { formattedDateTime, clearLocalStoragePreserveLanguage } from '@utils/utils';
import { clearSessionTime } from '@utils/authSession';

interface MainContentProps {
    listType: string;
}

const Dashboard = ({ listType }: MainContentProps) => {
    const [showModal, setShowModal] = useState(false);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    let userId = useAppSelector((state) => state.login.loggedInUserID);

    const handleSignOut = async () => {
        try {
            const userData = await getDataUsingUserId('user_info', userId);
            
            if (userData && userData.Items && userData.Items.length > 0) {
                const tableUuid = userData.Items[0].uuid.S;

                if(tableUuid) {
                    let attributeNames = {
                        '#fcm_token': 'fcm_token',
                        '#modified_by': 'modified_by',
                        '#modified_at': 'modified_at'
                    };
                
                    let attributeValues = {
                        ':fcm_token': { M: {} },
                        ':modified_by': { S: userId },
                        ':modified_at': { S: formattedDateTime },
                    };
                
                    let updateExpression =
                        'SET #fcm_token = :fcm_token, #modified_by = :modified_by, #modified_at = :modified_at';
                        
                    await updateUser('user_info', tableUuid, attributeNames, attributeValues, updateExpression);
                }
            }
            await signOut();
            clearSessionTime();
            clearLocalStoragePreserveLanguage();
            dispatch(logoutSuccess());
            // dispatch(logout());
            // navigate(LOGIN_PATH);
            window.location.href = LOGIN_PATH;
        } catch (error) {
            console.log('error signing out: ', error);
        }
    };
    return (
        <>
            <div className="flex h-screen" style={{ background: '#F1F5F9' }}>
                <Sidebar onLogoutClick={() => setShowModal(true)} />
                <div className="flex flex-col flex-1" style={{ minWidth: 0, overflow: 'hidden' }}>
                    <TopNav />
                    <MainContent listType={listType} />
                </div>
            </div>
            <ModalPopUp
                show={showModal}
                message={t('pop_up.logout')}
                onConfirm={handleSignOut}
                onCancel={() => setShowModal(false)}
            />
        </>
    );
};

export default Dashboard;
